/**
 * 遅延取得パネル（data 属性駆動。05_ui.md §6.4）
 *
 * マークアップ規約:
 *   <button data-lms-async-trigger
 *           data-lms-async-url="/admin/submissions/history?userId=1&curriculumId=x"
 *           data-lms-async-toggle="history-1"
 *           data-lms-async-target="history-body-1"
 *           aria-controls="history-body-1" aria-expanded="false">履歴（3 件）</button>
 *   <tr id="history-1" hidden>
 *     <td><div id="history-body-1"></div></td>
 *   </tr>
 *
 * htmx ではなく独自 fetch で取得する（htmx の処理対象にしない。05_ui.md §8）。取得した HTML
 * 断片は reinit（main.ts の initAll）で再初期化する。
 */

const MSG_LOAD_FAILED = "履歴の取得に失敗しました。";

export function initAsyncPanel(
  scope: ParentNode = document,
  reinit: (scope: ParentNode) => void = () => {},
): void {
  scope.querySelectorAll<HTMLElement>("[data-lms-async-trigger]").forEach((trigger) => {
    if (trigger.dataset["lmsAsyncReady"] === "1") return;

    const toggleId = trigger.dataset["lmsAsyncToggle"];
    const targetId = trigger.dataset["lmsAsyncTarget"];
    const url = trigger.dataset["lmsAsyncUrl"];
    const toggle = toggleId ? document.getElementById(toggleId) : null;
    const target = targetId ? document.getElementById(targetId) : null;
    if (!toggle || !target || !url) return;

    trigger.dataset["lmsAsyncReady"] = "1";

    trigger.addEventListener("click", () => {
      const willOpen = toggle.hidden;
      toggle.hidden = !willOpen;
      trigger.setAttribute("aria-expanded", String(willOpen));

      if (!willOpen || target.dataset["lmsAsyncLoaded"] === "1") {
        return;
      }

      // 取得中であることを支援技術に伝える（部品 #15）。表示は従来どおり素のテキスト。
      target.setAttribute("aria-busy", "true");
      target.textContent = "読み込み中…";
      fetch(url, {
        headers: { "X-Requested-With": "fetch" },
        credentials: "same-origin",
      })
        .then((response) => {
          if (!response.ok) {
            target.textContent = MSG_LOAD_FAILED;
            window.lmsToast(MSG_LOAD_FAILED, "error");
            return null;
          }
          return response.text();
        })
        .then((html) => {
          if (html === null || html === undefined) return;
          target.innerHTML = html;
          target.dataset["lmsAsyncLoaded"] = "1";
          reinit(target);
        })
        .catch(() => {
          target.textContent = MSG_LOAD_FAILED;
          window.lmsToast(MSG_LOAD_FAILED, "error");
        })
        .finally(() => {
          // 成功・HTTP エラー・通信エラーのいずれの経路でも必ず外す（部品 #15）
          target.removeAttribute("aria-busy");
        });
    });
  });
}
